import "@/sentry";  // Sentry init — must run before React import to catch boot errors
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";  // 3.27.0: i18n setup (IT/EN/ES/FR/DE)
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
